var map = {
	"./diagnostico-1-avatar.mp4": 7632,
	"./diagnostico-1-manuel.mp4": 2200,
	"./diagnostico-2-avatar.mp4": 6001,
	"./eventos-1-avatar.mp4": 7607,
	"./eventos-1-manuel.mp4": 672,
	"./evidencia-1-avatar.mp4": 5694,
	"./evidencia-1-manuel.mp4": 3643,
	"./evidencia-2-avatar.mp4": 3709,
	"./evidencia-2-manuel.mp4": 7594,
	"./medicamentos-manuel.mp4": 6681,
	"./metastasis-manuel.mp4": 3473,
	"./mujer-manuel.mp4": 2425,
	"./presentacion-caso-manuel.mp4": 9453,
	"./silent-video-manuel.mp4": 978,
	"./silent-video.mp4": 8511,
	"./start-chime.mp4": 9495,
	"./tratamiento-1-avatar.mp4": 9253,
	"./tratamiento-1-manuel.mp4": 9231,
	"./valoracion-geriatrica.mp4": 2450,
	"./vid_bg_home.mp4": 2239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 174;